/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';
import commonUtils from '../../utils/commonUtils';

export default function DayAppointments({ data, onShowMore, onClickDate, clickableDate }) {
  if (!data.total && !clickableDate) return <span />;

  let props = {
    className: `ec-week-day-appointments ec-week-day-appointments-${data.label}`,
    'aria-hidden': true,
    role: 'presentation',
  };

  if (onClickDate)
    props = {
      ...props,
      onClick: () => onClickDate(data),
      className: `ec-week-day-appointments ec-week-day-appointments-${data.label} ec-week-day-event`,
    };

  if (data.isCount) {
    return (
      <div
        className={`ec-week-day-appointments ec-week-day-appointments-count ec-week-day-appointments-${data.label}`}
      >
        <button className='ewdec-label' type='button' onClick={() => onShowMore(data)}>
          {data.total}
        </button>
      </div>
    );
  }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div {...props}>
      <div>
        {data?.showAppointments.map((row) => {
          const uuid = commonUtils.generateUUID();
          return (
            <div className={`ewde ewde-${uuid}`} key={uuid}>
              {row?.html ?? (
                <Tooltip title={row.label} className='ewde-tooltip' arrow>
                  <span>{row.label}</span>
                </Tooltip>
              )}
            </div>
          );
        })}
        {data.showMore ? (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events
          <div
            className='ewde-show-more'
            title={`Show ${data.showMoreRemaining} more appointments`}
            onClick={() => onShowMore(data)}
          >{`+${data.showMoreRemaining} more`}</div>
        ) : null}
      </div>
    </div>
  );
}

DayAppointments.defaultProps = {
  onClickDate: null,
  clickableDate: false,
};

DayAppointments.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    isDate: PropTypes.bool,
    isCurrentDate: PropTypes.bool,
    isSelectedDate: PropTypes.bool,
    date: PropTypes.string,
    label: PropTypes.number,
    showAppointments: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
      }),
    ),
    total: PropTypes.number,
    showMore: PropTypes.bool,
    showMoreRemaining: PropTypes.number,
    isCount: PropTypes.bool,
  }).isRequired,
  onShowMore: PropTypes.func.isRequired,
  onClickDate: PropTypes.func,
  clickableDate: PropTypes.bool,
};
